import React from 'react';
// import PropTypes from 'prop-types';
import './footer.css'

const Footer = () => (
  <div className='footer'>
    <footer>
      <p>For any suggestion on improving this site,
        <a href="mailto:adeniyikunle22@gmail.com"> mail me</a></p>
    </footer>
  </div>
);

// Footer.propTypes = {};

// Footer.defaultProps = {};

export default Footer;
